<template>
  <div class="topbar">
    <div class="topbar-operation">
      <div class="operation-left">
        <!-- 选择年级 -->
        <div class="select-grade">
          选择年级：
          <el-select
            v-model="gradeValue"
            :placeholder="gradePlaceholder"
            @change="selectGrade"
          >
            <el-option
              v-for="item in gradeSelectList"
              :key="item.gradeId"
              :label="item.gradeName"
              :value="item.gradeId"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- <div class="btns">
        <div class="add" @click="add">新增课程计划</div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["gradePlaceholder", "gradeSelectList"],
  data() {
    return {
      gradeValue: "",
    };
  },
  created() {},
  methods: {
    selectGrade(e) {
      this.$emit("selectGrade", e);
    },
    add() {
      this.$emit("addCourseScheduleShowSwitch", true);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./courseScheduleTopbar.scss";
</style>
